import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { CrudApi } from '../../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { TipoTarefaDto, TipoTarefaInput, TipoTarefaListItem } from './types';

const BASE = '/v1/task-types';

export const tiposTarefaApi: CrudApi<TipoTarefaListItem, TipoTarefaDto, TipoTarefaInput> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<TipoTarefaListItem>> {
    const { data } = await api.get<{
      data: TipoTarefaListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, { params: toGenexusParams(query) });
    return normalizeListEnvelope(data);
  },
  async get(id) {
    const { data } = await api.get<{ data: TipoTarefaDto }>(`${BASE}/${id}`);
    return data.data;
  },
  async create(input) {
    const { data } = await api.post<{ data: TipoTarefaDto }>(BASE, input);
    return data.data;
  },
  async update(id, input) {
    const { data } = await api.put<{ data: TipoTarefaDto }>(`${BASE}/${id}`, input);
    return data.data;
  },
  async remove(id) {
    await api.delete(`${BASE}/${id}`);
  },
};
